import React from 'react';
import MarkdownHelpText from './MarkdownHelpText';

const TextArea = ({ label, placeholder, value, onChange, className, rows = 5, theme = 'light' }) => (
  <div className={`w-full flex flex-col ${className}`}>
    <label className={`text-sm font-semibold mb-2 ml-1 ${theme === 'light' ? 'text-gray-700' : 'text-gray-300'}`}>
      {label}
    </label>
    <textarea
      className={`appearance-none block leading-7 w-full border rounded-lg py-3 px-4 focus:outline-none focus:ring-1 focus:ring-teal-500 transition-all duration-200 ${theme === 'light'
          ? 'bg-white text-gray-700 border-gray-300 focus:bg-white focus:border-teal-500'
          : 'bg-gray-800 text-gray-200 border-gray-700 focus:bg-gray-700 focus:border-teal-500'
        }`}
      rows={rows}
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
    />

    <MarkdownHelpText className="mt-2" />
  </div>
);

export default TextArea;
